import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion/accordion";
import { CreateRepaymentRequest } from "./comps/create-repayment-request";
import { getLoanRepaymentRequestsQueryOptions } from "@/config/queries/emp-query-options";
import { useMemo } from "react";
import { DataTable } from "./comps/repayment-requests-table/data-table";
import { columns } from "./comps/repayment-requests-table/columns";

export const RepaymentRequests = () => {
  const empKey = Cookies.get("key") as string;
  const { loanId } = useParams() as {
    loanId: string;
  };

  const { data, isPending, isFetching } = useQuery(
    getLoanRepaymentRequestsQueryOptions(empKey, loanId)
  );

  const repaymentRequestsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.requests === undefined) {
      return [];
    }

    const result = data?.requests?.map((req) => {
      return {
        id: req?._id,
        status: req?.status,
        amount: req?.amount,
        attachment: req?.attachment,
        employeeName: req?.employeeId?.name,
        employeeEmail: req?.employeeId?.email,
        createdAt: req?.createdAtIST,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="mb-6">
      <Accordion type="single" collapsible value={"item-1"}>
        <AccordionItem value="item-1">
          <AccordionTrigger className="text-lg">
            Repayment Requests
          </AccordionTrigger>
          <AccordionContent>
            <div className="space-y-3">
              <div className="flex items-center justify-end">
                <CreateRepaymentRequest />
              </div>

              <DataTable data={repaymentRequestsData} columns={columns} />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
